<template>
	<div class="grabage-enquiry-type" @click="respondevent">
		<div :style="[style]" class="content">
			{{ content() }}
		</div>
		<el-tooltip style="white-space: pre-line" placement="top">
			<div slot="content" style="white-space: pre-line; max-width: 250px;">{{ message }}</div>
			<span class="content-hint" v-show="showIcon"> 疑 </span>
		</el-tooltip>
	</div>
</template>

<script>
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {};
	},
	computed: {
		message() {
			if (!this.tableData.message) return '疑似垃圾询盘';
			if (typeof this.tableData.message === 'function') {
				return (this.tableData.message && this.tableData.message(this.scope.row)) || '-';
			} else {
				return this.tableData.message || '-';
			}
		},
		showIcon() {
			return this.tableData.showIcon && this.tableData.showIcon(this.scope.row);
		},
		style() {
			if (typeof this.tableData.style == 'function') {
				return this.tableData.style(this.scope.row);
			} else {
				return this.tableData.style;
			}
		},
	},
	methods: {
		content() {
			let val = this.scope.row[this.tableData.bind];
			return (
				(this.tableData.dataStyle && this.tableData.dataStyle(val, this.scope.row)) ||
				this.scope.row[this.tableData.bind]
			);
		},
		// 响应事件
		respondevent() {
			this.tableData.respondevent && this.tableData.respondevent(this.scope.row);
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.grabage-enquiry-type {
	display: flex;
	justify-content: flex-start;
	align-items: center;

	.content {
		// 单行溢出
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.content-hint {
		height: 24px;
		padding: 0 5px;
		line-height: 22px;
		border-radius: 4px;
		border: 1px solid rgba(255, 197, 61, 1);
		color: #ffc53d;
		font-size: 12px;
		text-align: center;
		margin-left: 4px;
		user-select: none;
		cursor: pointer;
	}
}
</style>
